import React from 'react';
import NavbarLayout from "../shared/components/navbarLayout";
import {useHistory} from "react-router-dom";
import {getRefCount, getRole, getUsername, isSuper, signOut} from "../shared/utils/SharedAuthentication";
import {useDispatch} from "react-redux";
import {toggleChangePassword} from "../shared/actions/setting";
import packageJson from "../../package.json";
import { useTranslation } from 'react-i18next';


export default function Navbar(props) {

    let history = useHistory();
    const dispatch = useDispatch();

    const { t, i18n } = useTranslation();
    const changeLanguage = (language) => {
      i18n.changeLanguage(language);
    };

    function expandPageNotification(){
        history.push("/notification-page");
    }

    function brand() {
        return <span onClick={()=> history.push("/")} className={"nav-logo"}>SENZWEB ADMIN</span>
    }
    function about() {
        window.open("https://senzagro.com", "_blank");
    }
    function showChangePassword() {
        dispatch(toggleChangePassword(true));

    }

    function logOut() {
        signOut();
        history.push("/login");
    }

    function onPaths(paths) {
        return (match, location) => location.pathname.match(paths);
    }

    let navItems=[
        { title:"Home",
            isActive:onPaths("/home"),
            to:"/home",
            permissions:true,
            webScreen:true,
            icon:"home",
        },{ title:"Blogs",
            isActive:onPaths("/blogs"),
            to:"/blogs",
            permissions:true,
            webScreen:true,
            icon:"file-text",
        },{ title:"Authors",
            isActive:onPaths("/authors"),
            to:"/authors",
            permissions:true,
            webScreen:true,
            icon:"user",
        },{ title:"Innovation",
            isActive:onPaths("/innovation"),
            to:"/innovation",
            permissions:true,
            webScreen:true,
            icon:"activity",
        }
    ]

    if (isSuper()) {
        navItems.push({
            title:"Users",
            isActive:onPaths("/users"),
            to:"/users",
            permissions:true,
            webScreen:true,
            icon:"users",
        })
    }

    let mobileNavbar=[
        {
            title:"SenzWeb Admin v" + packageJson.version,
            click:about,
            icon:"alert-circle"
        }, {
            title:"Change Password",
            click:showChangePassword,
            icon:"lock"
        }, {
            title:"Logout",
            click:logOut,
            icon:"log-out",
            logout:true
        }
    ]
    let txts={
        language:"Select Language",
        notifications:"Notifications",
        emptyNotifications:"There are no notifications",
        corporate:"Select Corporate",
    }
    let languages=[
        {
          title:t("title.ENGLISH"),
          lng:"en",
          icon:"E",
        },{
          title:t("title.TAMIL"),
          lng:"ta",
          icon:"T",
        },{
          title:t("title.SINHALA"),
          lng:"si",
          icon:"S",
        },{
          title:"JAPANESE",
          lng:"ja",
          icon:"J",
        }
    ]

    return (
        <div>
            <NavbarLayout notificationDot={false} txts={txts} settingPermission={false}
                          corporateEnable={false}
                          notificationActive={false}
                          expandPageNotification={expandPageNotification}
                          name={getUsername()} settingList={[]}languages={languages} changeLanguage={changeLanguage}navItems={navItems}
                          mobileNavbar={mobileNavbar} loadNotifications={[]} role={getRole()} refs={getRefCount()}
                          brand={() => brand()}/>
        </div>
    );
}
